"use client";
import { listenKeys } from "nanostores";
import { useCallback, useSyncExternalStore } from "react";
export function useStore(store, opts = {}) {
    const sub = useCallback((onChange) => opts.keys ? listenKeys(store, opts.keys, onChange) : store.listen(onChange), [opts.keys, store]);
    const get = store.get.bind(store);
    return useSyncExternalStore(sub, get, get);
}
//# sourceMappingURL=useStore.js.map